// Central backend URL resolution.
// On production custom domains (joinsahiri.com / www.joinsahiri.com) we use
// the SAME ORIGIN the user is browsing — the ingress serves /api on every
// attached host, so this is immune to apex vs www mismatches in the baked
// REACT_APP_BACKEND_URL. Everywhere else (preview, local dev) the env value
// is used as-is.
export function getBackendUrl() {
  if (typeof window !== 'undefined'
      && ['joinsahiri.com', 'www.joinsahiri.com'].includes(window.location.hostname.toLowerCase())) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL;
}

export const BACKEND_URL = getBackendUrl();
